import { useState } from "react";
import { validateEmail } from "../utils";
import Fronter from "./Fronter";

let Home = function () {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [role, setRole] = useState("role");

  const [rightPass, setRightpass] = useState("");
  const [statusPass, setStatusPass] = useState(false);

  let passValid = function (e) {
    console.log(e.target.value.length);
    setPassword(e.target.value);
    if (e.target.value.length >= 8) {
      setRightpass(<p className="noError">Valid password!</p>);
      setStatusPass(true);
    } else {
      setRightpass(
        <p className="FieldError">Password should have at least 8 characters</p>
      );
    }
  };

  const getIsFormValid = () => {
    // Implement this function
    return true;
  };

  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setRole("");
    setStatusPass(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    //VALIDATING EMAIL
    let isValid = validateEmail(email);
    if (isValid) {
      console.log("Yes");
    } else {
      alert("Invalid email");
      console.log("No");
      return;
    }
    //VALIDATING PASSWORD
    if (!statusPass) {
      return;
    } else {
      alert("Account created!");
      clearForm();
    }
    console.log(password);

    /**/
  };

  return (
    <div className="App">
      <form onSubmit={handleSubmit}>
        <h2>Sign Up</h2>
        <fieldset>
          <div className="Field">
            <label>
              First name <sup>*</sup>
            </label>
            <input
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="Field">
            <label>Last name</label>
            <input
              placeholder="Last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="Field">
            <label>
              Email address <sup>*</sup>
            </label>
            <input
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="Field">
            <label>
              Password <sup>*</sup>
            </label>
            <input
              placeholder="Password"
              value={password}
              onChange={passValid}
              type="password"
            />
            <span>{rightPass}</span>
          </div>
          <div className="Field">
            <label>
              Role <sup>*</sup>
            </label>
            <select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value="role">Role</option>
              <option value="individual">Individual</option>
              <option value="business">Business</option>
            </select>
          </div>
          <button type="submit" disabled={!getIsFormValid()}>
            Create account
          </button>
        </fieldset>
      </form>
      <Fronter>Hola</Fronter>
      <Fronter>No able</Fronter>
      <Fronter>
        <button>Start</button>
      </Fronter>
    </div>
  );
};

export default Home;
